import React from "react";
import Image from "next/image";
import Stepicon1 from "@/public/static/images/step_icon-1.png";
import Stepicon2 from "@/public/static/images/step_icon-2.png";
import Stepicon3 from "@/public/static/images/step_icon-3.png";
import Link from "next/link";
import Button from "@mui/material/Button";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
function MainStep() {
  return (
    <div className="row row-cols-1 row-cols-md-3 g-4">
      <div className="col">
        <Link href="/th/instrument">
          <div className="card h-100 card-step">
            <Image
              loading="lazy"
              src={Stepicon1}
              alt="Stamping???"
              width={300}
            />
            <div className="card-body">
              <h5 className="card-title fw-bold">การปั๊ม</h5>
              <div className="hstack gap-5">
                <div className="step_content">
                  <span>
                    การปั๊ม : การปั๊มขึ้นรูปจะมีความยาก ไม่ว่าจะเป็น
                    การปั๊มอัตโนมัติ, การปั๊มแบบส่งต่อ (Transfer stamping),
                    การปั๊มเดี่ยว (Single stamping) โดยเฉพาะการปั๊มอลูมิเนียม{" "}
                  </span>
                </div>
                <div className="step_link ms-auto">
                  <Button variant="contained">
                    <KeyboardArrowRightIcon />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
      <div className="col">
        <Link href="/th/instrument">
          <div className="card h-100 card-step">
            <Image
              loading="lazy"
              src={Stepicon2}
              alt="CNC Machining???"
              width={300}
            />
            <div className="card-body">
              <h5 className="card-title fw-bold">ซีเอ็นซี​</h5>
              <div className="hstack gap-5">
                <div className="step_content">
                  <span>การผลิตที่มีคุณภาพและ​ความแม่นยำสูง</span>
                </div>
                <div className="step_link ms-auto">
                  <Button variant="contained">
                    <KeyboardArrowRightIcon />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
      <div className="col">
        <Link href="/th/instrument">
          <div className="card h-100 card-step">
            <Image
              loading="lazy"
              src={Stepicon3}
              alt="Anodizing??????"
              width={300}
            />
            <div className="card-body">
              <h5 className="card-title fw-bold">อโนไดซ์</h5>
              <div className="hstack gap-5">
                <div className="step_content">
                  <span>
                    มีทั้งแบบทำสีและไม่ทำสีสำหรับชิ้นส่วนรถยนต์,ชิ้นส่วนเครื่องเสียงชั้นดี
                    และชิ้นงานอื่นๆ
                  </span>
                </div>
                <div className="step_link ms-auto">
                  <Button variant="contained">
                    <KeyboardArrowRightIcon />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
export default MainStep;
